import React, { Component } from 'react'
import { Line } from 'react-chartjs-2'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import {
  TX_STATUS_COMPLETED,
  TX_STATUS_CUSTOMER_REVIEW,
  TX_STATUS_FAILED,
  TX_STATUS_HOLD,
  TX_STATUS_POST_PROCESSING,
  TX_STATUS_RESTARTED,
} from '../../config'
import NoData from './noData'

const options = {
  maintainAspectRatio: false,
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          callback: (value) => (value % 1 === 0 ? value : null),
        },
      },
    ],
  },
}

const datasets = (color) => ({
  fill: false,
  lineTension: 0.1,
  backgroundColor: color,
  borderColor: color,
  // borderCapStyle: 'butt',
  // borderDash: [],
  // borderDashOffset: 0.0,
  borderJoinStyle: 'miter',
  pointBorderColor: color,
  pointBackgroundColor: '#fff',
  pointBorderWidth: 1,
  pointHoverRadius: 5,
  pointHoverBackgroundColor: color,
  pointHoverBorderColor: color,
  pointHoverBorderWidth: 2,
  pointRadius: 3,
  pointHitRadius: 10,
})

class TotalTx extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chartData: {},
      noData: false,
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { props } = this
    if (prevProps.data !== props.data) {
      if (props.data && props.data.transaction_data) {
        const labels = []
        const completed = []
        const failed = []
        const hold = []
        const review = []
        const restarted = []
        const customerReview = []
        const t = {}
        props.data.transaction_data.by_date.forEach(({ count, date, state }) => {
          // completeData.push(count)
          // labels.push(date)
          if (t[date]) {
            t[date][state] = count
          } else {
            t[date] = {
              [TX_STATUS_COMPLETED]: 0,
              [TX_STATUS_FAILED]: 0,
              [TX_STATUS_HOLD]: 0,
              [TX_STATUS_POST_PROCESSING]: 0,
              [TX_STATUS_RESTARTED]: 0,
              [TX_STATUS_CUSTOMER_REVIEW]: 0,
            }
            t[date][state] = count
          }
        })
        Object.entries(t).forEach(([date, state]) => {
          labels.push(date)
          completed.push(state[TX_STATUS_COMPLETED])
          failed.push(state[TX_STATUS_FAILED])
          hold.push(state[TX_STATUS_HOLD])
          review.push(state[TX_STATUS_POST_PROCESSING])
          restarted.push(state[TX_STATUS_RESTARTED])
          customerReview.push(state[TX_STATUS_CUSTOMER_REVIEW])
        })

        const chartData = {
          labels,
          datasets: [
            { ...datasets('#1ab394'), data: completed, label: 'Approved' },
            { ...datasets('#f8ac59'), data: hold, label: 'Hold' },
            { ...datasets('#1c84c6'), data: restarted, label: 'Restarted' },
            { ...datasets('#ed5565'), data: failed, label: 'Declined' },
            { ...datasets('#512D8C'), data: review, label: 'Netki Review' },
            { ...datasets('#512D8C'), data: customerReview, label: 'Customer Review' },
          ],
        }

        if (chartData.datasets.map((i) => i.data).flat().length === 0) {
          this.setState({ noData: true })
        } else {
          this.setState({ noData: false })
          this.setState({ chartData })
        }
      }
    }
  }

  render() {
    return (
      <div className='ibox float-e-margins animated fadeIn'>
        <div className='ibox-title'>
          <h5>
            Transactions For&nbsp;
            {this.props.timeSpan}
          </h5>
          <div className='text-end'>{/* <TimeSpanDropdown onUpdate={this.handleDropdownClick} /> */}</div>
        </div>
        {this.state.noData && <NoData />}
        {!this.state.noData && (
          <div className='ibox-content' style={{ height: 350 }}>
            <Line data={this.state.chartData} options={options} />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.allMetrics.isFetching,
  errorMessage: state.allMetrics.errorMessage,
  data: state.allMetrics.results,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TotalTx))
